import React from "react";

import { Link } from "../../../Link";
import { NotificationSection } from "../../../NotificationSection";
import { SUPPORT_NUMBER, SUPPORT_NUMBER_HREF } from "../../../../constants/aptihealth";
import { Text } from "../../../Text";

import "./styles.scss";

// Relates to: Profile Insurance Status

export const Declined = ({ carrier, copay, dateChecked }) => {
  return (
    <NotificationSection className="declined">
      <Text className="bold mb-3">
        Unfortunately, your new insurance does not cover aptihealth's services.
      </Text>

      <Text>
        <>
          <div className="mb-3">
            Contact <Link href="mailto:support@aptihealth.com">support@aptihealth.com</Link> or{" "}
            <Link href={SUPPORT_NUMBER_HREF}>{SUPPORT_NUMBER}</Link> before your next appointment to
            prevent billing issues.
          </div>
          <div>Checked: {dateChecked}</div>
        </>
      </Text>
    </NotificationSection>
  );
};

Declined.defaultProps = {
  carrier: "",
  copay: null,
  dateChecked: "",
};
